import ActivityBox from './ActivityBox';

export default ActivityBox;
